import { lazy, Suspense, useEffect } from "react";
import "@grapecity/spread-sheets/styles/gc.spread.sheets.excel2013white.css";
import "@grapecity/spread-sheets-charts";

import { SpreadWrapperProvider } from "./shared/screen-components/ExcelViewComponent/SpreadWrapperContext";
import { AgGridProvider } from "./shared/screen-components/AgGridComponent/AgGridContext";
import { ThemeProvider } from "./theme";
import { PartnershipProvider } from "./core/context/PartnershipContext";
import { PageLoader } from "./shared/base-components/PageLoader/PageLoader";

const AppRoute = lazy(() => import("./App.route"));

function App() {
  useEffect(() => {
    // Redirect handling moved to index.tsx (pre-render).
    // App.tsx no longer needs to call handleRedirectPromise().
  }, []);

  return (
    <div className="App">
      <ThemeProvider>
        <PartnershipProvider>
          <AgGridProvider>
            <SpreadWrapperProvider>
              <Suspense fallback={<PageLoader />}>
                <AppRoute />
              </Suspense>
            </SpreadWrapperProvider>
          </AgGridProvider>
        </PartnershipProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
